module.exports = __webpack_public_path__ + "static/media/td.d39cd5f9.svg";